import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import SpecialtiesSection from './components/SpecialtiesSection';
import GallerySection from './components/GallerySection';
import ClassesSection from './components/ClassesSection';
import TestimonialsSection from './components/TestimonialsSection';
import SocialSection from './components/SocialSection';
import LocalSection from './components/LocalSection';
import OrderFormSection from './components/OrderFormSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-cream-50 font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <SpecialtiesSection />
        <GallerySection />
        <ClassesSection />
        <TestimonialsSection />
        <SocialSection />
        <LocalSection />
        <OrderFormSection />
      </main>
      <Footer />
    </div>
  );
}
